import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseListIcon = ({ className }: IProps) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM2 12a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM2 19.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM8.25 5.125c0-.345.28-.625.625-.625h12.5a.625.625 0 1 1 0 1.25h-12.5a.625.625 0 0 1-.625-.625ZM8.25 12.625c0-.345.28-.625.625-.625h12.5a.625.625 0 1 1 0 1.25h-12.5a.625.625 0 0 1-.625-.625ZM8.25 20.125c0-.345.28-.625.625-.625h12.5a.625.625 0 1 1 0 1.25h-12.5a.625.625 0 0 1-.625-.625Z"
            clipRule="evenodd"
        ></path>
    </svg>
);

export const ListIcon = styled(BaseListIcon)``;
